export default {"src":"/_next/static/media/section-6-bg-1.7fd46c9e.svg","height":163,"width":164,"blurWidth":0,"blurHeight":0};